// Planes del asistente por mes (script 51). Los topes semanales que la tabla `plans` ya tenía se llenan con el equivalente solo para
// que sigan siendo coherentes: ya no controlan nada.
const WEEKS_PER_MONTH = 4.345;
const toInt = (v) => (v === '' || v == null ? null : Math.round(Number(v)));
const weekly = (monthly) => (monthly == null ? null : Math.max(0, Math.ceil(monthly / WEEKS_PER_MONTH)));

/** Del formulario ({name, turns, minutes, usd}) a las columnas de `plans`. Vacío = sin tope (null). */
export function planCaps({ name, turns, minutes, usd }) {
  const t = toInt(turns);
  const m = toInt(minutes);
  const cap = usd === '' || usd == null ? null : Math.round(Number(usd) * 100) / 100;
  const out = {
    name: String(name || '').trim(),
    assistant_text_turns_monthly: t,
    assistant_voice_minutes_monthly: m,
    assistant_cost_cap_usd_monthly: cap,
  };
  // columnas semanales heredadas: solo si hay tope mensual; si no, la base usa su valor por defecto
  if (t != null) out.text_limit_weekly = weekly(t);
  if (m != null) out.voice_limit_weekly = weekly(m);
  return out;
}

const num = (v) => Number(v).toLocaleString('es-MX');
export const planCapsLabel = {
  turns: (v) => (v == null ? 'Sin tope' : `${num(v)} mensajes`),
  minutes: (v) => (v == null ? 'Sin tope' : `${num(v)} min`),
  usd: (v) => (v == null ? 'Sin tope' : `$${Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`),
};
